// import React from "react";
// import "./PrivacyPolicy.scss";

// const PrivacyPolicy = () => {
//   const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
//   const contactPhone = process.env.REACT_APP_CONTACT_PHONE;
//   return (
//     <div class="privacy-page">
//       <main class="content">
//         <h1>Privacy Policy</h1>
//         <p>
//           <strong>Effective Date:</strong> 09 June 2025
//         </p>
//         <p>
//           <strong>Website:</strong>{" "}
//           <a href="https://www.beckynews.com">https://www.beckynews.com</a>
//         </p>
//         <p>
//           <strong>Contact Email:</strong>{" "}
//           <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
//         </p>
//         <p>
//           <strong>Phone:</strong> {contactPhone}
//         </p>

//         <section>
//           <h2>1. Information We Collect</h2>
//           <p>
//             We may collect personal information such as your name, email
//             address, IP address, browser details, and usage data when you
//             interact with our site.
//           </p>
//         </section>

//         <section>
//           <h2>2. How We Use Your Information</h2>
//           <p>
//             We use this information to enhance user experience, improve site
//             functionality, respond to inquiries, send updates, and display
//             relevant advertisements.
//           </p>
//         </section>

//         <section>
//           <h2>3. Cookies and Tracking</h2>
//           <p>
//             BeckyNews uses cookies to remember your preferences, analyze website
//             traffic, and provide personalized content and ads. You can disable
//             cookies in your browser settings.
//           </p>
//         </section>

//         <section>
//           <h2>4. Google AdSense</h2>
//           <p>
//             We use Google AdSense to display ads. Google may use cookies, such
//             as the DoubleClick cookie, to serve personalized ads based on your
//             visits to this and other websites.
//           </p>
//           <p>
//             To manage your preferences or opt out of personalized ads, visit{" "}
//             <a href="https://www.google.com/settings/ads" target="_blank">
//               google.com/settings/ads
//             </a>
//             .
//           </p>
//         </section>

//         <section>
//           <h2>5. Third-Party Policies</h2>
//           <p>
//             This Privacy Policy does not apply to other websites or services
//             linked from BeckyNews. Please review their policies individually.
//           </p>
//         </section>

//         <section>
//           <h2>6. GDPR & CCPA Rights</h2>
//           <p>
//             Users in the European Economic Area (EEA) or California have the
//             right to access, update, or delete personal data. To make such a
//             request, please contact us at{" "}
//             <a href={`mailto:${contactEmail}`}>{contactEmail}</a>.
//           </p>
//         </section>

//         <section>
//           <h2>7. Children’s Privacy</h2>
//           <p>
//             We do not knowingly collect personal information from children under
//             13. If you believe your child has provided such data, contact us
//             immediately for removal.
//           </p>
//         </section>

//         <section>
//           <h2>8. Policy Updates</h2>
//           <p>
//             We may update this Privacy Policy from time to time. Any changes
//             will be posted here with an updated effective date.
//           </p>
//         </section>

//         <section>
//           <h2>9. Contact</h2>
//           <p>Have questions or concerns? Reach out:</p>
//           <ul>
//             <li>
//               📧 Email: <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
//             </li>
//             <li>📞 Phone: {contactPhone}</li>
//           </ul>
//         </section>
//       </main>
//     </div>
//   );
// };

// export default PrivacyPolicy;

// src/pages/PrivacyPolicy.jsx
import styles from "./PrivacyPolicy.module.scss";

export default function PrivacyPolicy() {
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
  const contactPhone = process.env.REACT_APP_CONTACT_PHONE;
  return (
    <div className={styles["legal-container"]}>
      <h1 className={styles["legal-title"]}>Privacy Policy</h1>

      <p className={styles["legal-paragraph"]}>
        At BeckyNews, we are committed to protecting your privacy. This Privacy
        Policy outlines how we collect and use your data.
      </p>

      <h2 className={styles["legal-subtitle"]}>1. Information We Collect</h2>
      <ul className={styles["legal-list"]}>
        <li>Name and email address when you contact us</li>
        <li>IP address and browser type for analytics</li>
        <li>Cookies to personalize user experience</li>
      </ul>

      <h2 className={styles["legal-subtitle"]}>
        2. How We Use Your Information
      </h2>
      <ul className={styles["legal-list"]}>
        <li>To provide and improve our website</li>
        <li>To communicate with users</li>
        <li>To prevent spam and fraud</li>
      </ul>

      <h2 className={styles["legal-subtitle"]}>3. Your Rights</h2>
      <p className={styles["legal-paragraph"]}>
        You may request access, correction, or deletion of your data at any time
        by contacting us at <br />
        <a href={`mailto:${contactEmail}`}>
          <span className={styles["legal-contact"]}>
            📧 Email: {contactEmail}
          </span>
        </a>
        .
      </p>
      <p className={styles["legal-paragraph"]}>
        <span className={styles["legal-contact"]}>📞 call: {contactPhone}</span>
      </p>

      <h2 className={styles["legal-subtitle"]}>4. Children’s Privacy</h2>
      <p className={styles["legal-paragraph"]}>
        We do not knowingly collect information from children under 13. Contact
        us if you believe we have.
      </p>
    </div>
  );
}
